module.exports = __webpack_public_path__ + "img/hugo_conquerant.95726e0d.webp";